import styled from 'styled-components';

export const P = styled.p`
    font-size: 1.25rem;
`;
